/**
 * Main Site files to include.
 */

import './footer.js';
import './header.js';
// @DEV - DM-986 - replacing with Team DM Nav
// import './dm-family.js';
import TeamDMDropdownController from './team-dm-nav.js';
TeamDMDropdownController.initialize();

import './lazy.js';

import './vendor';

/* COMPONENT SCRIPT IMPORTS */
import Columns from '../../components/columns/_script';
import ColumnsWithScroll from '../../components/columns-with-scroll/_script';
import CaseStudies from '../../components/case-studies/_script';
import ColumnsWithScrollAndDetail from '../../components/columns-with-scroll-and-detail/_script';
import Quote from '../../components/quote/_script';
import ComparisonChart from '../../components/comparison-chart/_script';
import HomeHero from '../../components/home-hero/_script';
import MaterialDetailHero from '../../components/material-detail-hero/_script.js';
import ProductDetailHero from '../../components/product-detail-hero/_script.js';
import safetyDataSheets from '../../components/safety-data-sheet-links/_script.js';

/* COMPONENT LAUNCHER
	- takes a query (element Class or Id), and passes all matching Nodes to the given function.
	- takes a function that will be passed the DOM Node of each element that matches the Query criteria
*/
const launchComponents = (componentQuery, componentFunction) => {
	document.querySelectorAll(componentQuery).forEach((element) => {
		componentFunction(element);
	});
};

/* COMPONENTS
	in order for your '_script' partial for your Component to be launched,
	please do the following:

	1. import your _script
		(e.g import MyComponent from '@components/my-component/_script;')
	2. add a launchComponents call, passing it your imported _script
		and a DOM Query for the Launcher
		(e.g launchComponents('.my-component#my-component-id', MyComponent); )
*/

launchComponents('.columns', Columns);
launchComponents('.columns-with-scroll', ColumnsWithScroll);
launchComponents('.case-studies', CaseStudies);
launchComponents('.columns-with-scroll-and-detail', ColumnsWithScrollAndDetail);
launchComponents('.quote', Quote);
launchComponents('.comparison-chart', ComparisonChart);
launchComponents('.home-hero', HomeHero);
launchComponents('.material-detail-hero__links-wrapper', MaterialDetailHero);
launchComponents('.product-detail-hero__links-wrapper', ProductDetailHero);
launchComponents('.safety-d-s', safetyDataSheets);
